import {
  Box,
  Heading,
  IconMoney,
  IconThumb,
  Loader,
  Stack,
  Text,
} from 'braid-design-system';

import CircularProgress from './CircularProgress';

import { formatRating } from '@seek/libs-shared';
import * as styles from './PercentageWheel.css';

interface PercentageWheelModel {
  percentage?: number;
}

interface Props {
  mode: 'view' | 'edit';
  isMoney?: boolean;
  loading?: boolean;
  model?: PercentageWheelModel;
  showIcon?: boolean;
  text?: string;
}
export const PercentageWheel = ({
  model,
  text,
  isMoney = false,
  showIcon = true,
  loading,
}: Props) => {
  if (loading) {
    return <Loader />;
  }
  const percentage = model?.percentage || 0;
  return (
    <Stack space="small" align="center">
      <Box className={styles.greyCircle}>
        <Box className={styles.whiteCircle}>
          {percentage >= 70 && showIcon && (
            <Box className={styles.circleIcon}>
              {isMoney ? (
                <IconMoney tone="formAccent" size="small" />
              ) : (
                <IconThumb tone="formAccent" size="small" />
              )}
            </Box>
          )}
          <Box className={styles.circleText}>
            <Heading level="3" weight="weak" component="span">
              {formatRating(percentage)}%
            </Heading>
          </Box>
        </Box>
        <CircularProgress progress={percentage} />
      </Box>
      <Text size="small" align="center">
        {text}
      </Text>
    </Stack>
  );
};
